/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CalibrationDataDtoCalibrationState } from './CalibrationDataDtoCalibrationState';
import {
    CalibrationDataDtoCalibrationStateFromJSON,
    CalibrationDataDtoCalibrationStateFromJSONTyped,
    CalibrationDataDtoCalibrationStateToJSON,
} from './CalibrationDataDtoCalibrationState';
import type { CalibrationDataType } from './CalibrationDataType';
import {
    CalibrationDataTypeFromJSON,
    CalibrationDataTypeFromJSONTyped,
    CalibrationDataTypeToJSON,
} from './CalibrationDataType';

/**
 * 
 * @export
 * @interface CalibrationDataDto
 */
export interface CalibrationDataDto {
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof CalibrationDataDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CalibrationDataDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    masterDeviceId: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    erpDeviceId: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibrationCertificateNumber: string;
    /**
     * 
     * @type {CalibrationDataType}
     * @memberof CalibrationDataDto
     */
    calibrationDataType?: CalibrationDataType;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    dataVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibratedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    activationDate?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCalibrationState}
     * @memberof CalibrationDataDto
     */
    calibrationState?: CalibrationDataDtoCalibrationState | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    $type?: CalibrationDataDtoTypeEnum;
}


/**
 * @export
 */
export const CalibrationDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCalibrationDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CalibrationDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CalibrationDataDtoTypeEnum = typeof CalibrationDataDtoTypeEnum[keyof typeof CalibrationDataDtoTypeEnum];


/**
 * Check if a given object implements the CalibrationDataDto interface.
 */
export function instanceOfCalibrationDataDto(value?: unknown): value is CalibrationDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CalibrationDataDtoTypeEnum)[0];
}

export function CalibrationDataDtoFromJSON(json: any): CalibrationDataDto {
    return CalibrationDataDtoFromJSONTyped(json, false);
}

export function CalibrationDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'masterDeviceId': json['masterDeviceId'],
        'erpDeviceId': json['erpDeviceId'],
        'calibrationDate': !exists(json, 'calibrationDate') ? undefined : json['calibrationDate'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'],
        'calibrationDataType': !exists(json, 'calibrationDataType') ? undefined : CalibrationDataTypeFromJSON(json['calibrationDataType']),
        'dataVersion': !exists(json, 'dataVersion') ? undefined : json['dataVersion'],
        'calibratedBy': !exists(json, 'calibratedBy') ? undefined : json['calibratedBy'],
        'activationDate': !exists(json, 'activationDate') ? undefined : json['activationDate'],
        'calibrationState': !exists(json, 'calibrationState') ? undefined : CalibrationDataDtoCalibrationStateFromJSON(json['calibrationState']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CalibrationDataDtoToJSON(value?: CalibrationDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'masterDeviceId': value.masterDeviceId,
        'erpDeviceId': value.erpDeviceId,
        'calibrationDate': value.calibrationDate,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'calibrationDataType': CalibrationDataTypeToJSON(value.calibrationDataType),
        'dataVersion': value.dataVersion,
        'calibratedBy': value.calibratedBy,
        'activationDate': value.activationDate,
        'calibrationState': CalibrationDataDtoCalibrationStateToJSON(value.calibrationState),
        '$type': value.$type,
    });
}

